import { Component } from '@angular/core';

@Component({
  selector: 'app-load',
  template: `<div class="load-content"><mat-spinner></mat-spinner></div>`,
  styleUrls: ['./load.component.scss']
})
export class LoadComponent { }
